import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'recrewt-primary-bg-layout',
  templateUrl: './primary-bg-layout.component.html',
  styleUrls: ['./primary-bg-layout.component.scss'],
  standalone: false,
})
export class PrimaryBgLayoutComponent {
  location = inject(Location);
}
